var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNocolour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.59,
    height: 13.626,
    viewBox: "0 0 15.59 13.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M982.13,918.216l-7.3-12.636c-.222-.386-.04-.7.4-.7h14.591c.446,0,.627.316.4.7l-7.3,12.636a.427.427,0,0,1-.808,0",
    transform: "translate(-974.739 -904.878)",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 30.208,
    height: 28.244,
    transform: "translate(-7.309 -7.309)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNocolour);
export default __webpack_public_path__ + "static/media/Arrow-nocolour.13d366a37a55ed058b98191936bd924e.svg";
export { ForwardRef as ReactComponent };